// OPERATION COUNT API
import Request from '../base'
export default {
  countOrg (options) {
    return Request.post('/ebercount/countapi/operation/count/org', options)
  },
  countUser (options) {
    return Request.post('/ebercount/countapi/operation/count/user', options)
  },
  countOrgAnaesthesia (options) {
    return Request.post('/ebercount/countapi/operation/count/org/anaesthesia', options)
  },
  countUserAnaesthesia (options) {
    return Request.post('/ebercount/countapi/operation/count/user/anaesthesia', options)
  },
  rank (options) {
    return Request.post('/ebercount/countapi/operation/count/rank', options)
  }
}
